<template>
  <el-form label-position="top" ref="form" :model="data">
    <el-row>
      <h2>连接信息</h2>
      <el-input v-model="data.cs_pt_class" readonly></el-input>
      <el-col :span="12">
        <el-form-item label="连接协议标识">
          <el-input v-model="data.cs_pt_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="连接协议名称">
          <el-input v-model="data.cs_pt_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="连接标识">
          <el-input v-model="data.cs_cn_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="连接名称">
          <el-input v-model="data.cs_cn_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="连接池容量">
          <el-input v-model="data.cs_cn_poolsize" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="终端信息">
          <el-input v-model="data.cs_cn_conf" readonly></el-input>
        </el-form-item>
      </el-col>
      <h2>终端信息</h2>
      <el-input v-model="data.pd_class" readonly></el-input>
      <el-col :span="12">
        <el-form-item label="终端标识">
          <el-input v-model="data.pd_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="终端名称">
          <el-input v-model="data.pd_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="终端状态">
          <el-input v-model="data.pd_status" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="终端字符集">
          <el-input v-model="data.pd_charset" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="连接池容量">
          <el-input v-model="data.pd_cnnum" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="终端配置">
          <el-input v-model="data.pd_conf" readonly></el-input>
        </el-form-item>
      </el-col>

      <h2>持久化信息</h2>
      <el-input v-model="data.cm_class" readonly></el-input>
      <el-col :span="12">
        <el-form-item label="组件标识">
          <el-input v-model="data.cm_defn" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="组件名称">
          <el-input v-model="data.cm_name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="持久化组件配置">
          <el-input v-model="data.cm_conf" readonly></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    datpd: {}
  },
  data () {
    return {
      data: {},
      options: []
    }
  },
  // 当前组件显示到页面之后立即执行，（挂载到页面）
  mounted () {
    this.loadInfo()
  },
  watch: {
    dat: function () {
      this.loadInfo()
    }
  },
  methods: {
    loadInfo () {
      this.data = this.datpd
      /*   this.data.item_name = this.datpd.itemname;
      this.data.item_conf = this.datpd.itemconf;
      this.data.item_uuid = this.datpd.itemuuid;
      this.data.opcomment = this.datpd.opcomment; */
    }
  }
}
</script>

<style>

</style>
